import { render, staticRenderFns } from "./UserEditedFormatsSelector.vue?vue&type=template&id=a2f68d42&scoped=true&"
import script from "./UserEditedFormatsSelector.vue?vue&type=script&lang=ts&"
export * from "./UserEditedFormatsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./UserEditedFormatsSelector.vue?vue&type=style&index=0&id=a2f68d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f68d42",
  null
  
)

export default component.exports